// src/locales/ta/courierInvoice.js
export const courierInvoice = {
  // Page Titles
  uploadInvoice: "கூரியர் விலைப்பட்டியல் பதிவேற்றவும்",
  allInvoices: "கூரியர் விலைப்பட்டியல்கள்",
  invoiceDetails: "விலைப்பட்டியல் விவரங்கள்",

  // Form Fields
  selectCourierAccount: "கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்",
  courierAccount: "கூரியர் கணக்கு",
  invoiceNumber: "விலைப்பட்டியல் எண்",
  invoiceDate: "விலைப்பட்டியல் தேதி",
  uploadFile: "கோப்பைப் பதிவேற்றவும்",

  // File Upload
  dropFileHere: "கோப்பை இங்கே விடுங்கள் அல்லது கிளிக் செய்து தேர்ந்தெடுக்கவும்",
  supportsFiles: ".xlsx, .xls மற்றும் .csv கோப்புகள் ஆதரிக்கப்படும்",
  selectFile: "கோப்பைத் தேர்ந்தெடுக்கவும்",
  fileSelected: "கோப்பு தேர்ந்தெடுக்கப்பட்டது",
  removeFile: "கோப்பை நீக்கவும்",

  // Column Mapping
  columnMapping: "நெடுவரிசை இணைப்பு",
  columnMappingLoaded: "Column mapping loaded",
  mappingWarnings: "Column mapping எச்சரிக்கை",
  missingColumn: "தேவையான நெடுவரிசை இல்லை",
  downloadTemplate: "Template ஐ பதிவிறக்கவும்",

  // File Preview
  filePreview: "கோப்பு முன்னோட்டம்",
  firstRows: "முதல் 5 வரிகள்",

  // Eligible Orders
  eligibleOrders: "தகுதி வாய்ந்த ஆர்டர்கள்",
  totalValue: "மொத்த மதிப்பு",

  // Processing
  startProcessing: "செயலாக்கத்தை தொடங்கவும்",
  processing: "செயலாக்கப்படுகிறது",
  processingInvoice: "விலைப்பட்டியல் செயலாக்கப்படுகிறது",
  processingChunk: "Chunk செயலாக்கப்படுகிறது",
  ordersProcessed: "orders செயலாக்கப்பட்டது",
  pauseUpload: "இடைநிறுத்தம்",
  resumeUpload: "தொடரவும்",
  cancelUpload: "பதிவேற்றலை ரத்து செய்யவும்",

  // Progress Stats
  matched: "Matched",
  notFound: "Not Found",
  alreadyInvoiced: "ஏற்கனவே விலைப்பட்டியல் உள்ளது",
  ineligible: "தகுதி அற்றது",
  errors: "Errors",

  // Results
  processingComplete: "செயலாக்கம் முடிந்தது",
  totalOrders: "மொத்த ஆர்டர்கள்",
  delivered: "Delivered",
  returned: "Returned",
  financialSummary: "நிதி சுருக்கம்",
  codCollected: "COD வசூலிப்பு",
  courierCharges: "கூரியர் கட்டணங்கள்",
  netAmountPayable: "செலுத்த வேண்டிய தொகை",

  // Actions
  viewInvoiceDetails: "விலைப்பட்டியல் விவரங்களை பார்க்கவும்",
  uploadAnotherInvoice: "மற்றொரு விலைப்பட்டியல் பதிவேற்றவும்",
  downloadErrorReport: "Error Report பதிவிறக்கவும்",
  reprocessFailed: "தோல்வியடைந்த orders மீண்டும் process செய்யவும்",
  deleteInvoice: "விலைப்பட்டியல் நீக்கவும்",

  // Messages
  invoiceUploadedSuccessfully: "விலைப்பட்டியல் வெற்றிகரமாக செயலாக்கப்பட்டது!",
  invoiceUploadCancelled: "பதிவேற்றம் ரத்து செய்யப்பட்டது",
  failedToLoadCouriers: "கூரியர் கணக்குகளை Load செய்ய முடியவில்லை",
  failedToLoadMapping: "Column mapping Load செய்ய முடியவில்லை",
  invalidFileType: "சரியான Excel அல்லது CSV கோப்பை பதிவேற்றவும்",
  fileMustHaveData: "கோப்பில் header மற்றும் data இருக்க வேண்டும்",
  failedToReadFile: "கோப்பை படிக்க முடியவில்லை",
  selectCourierFirst: "முதலில் கூரியர் கணக்கைத் தேர்ந்தெடுக்கவும்",
  enterInvoiceNumber: "விலைப்பட்டியல் எண்ணை உள்ளிடவும்",
  selectInvoiceDate: "விலைப்பட்டியல் தேதியைத் தேர்ந்தெடுக்கவும்",
  uploadFileFirst: "முதலில் கோப்பு பதிவேற்றவும்",
  mappingWarningsConfirm: "Column mapping warning(s). தொடர்ந்து செல்ல வேண்டுமா?",
  cancelUploadConfirm: "பதிவேற்றலை ரத்து செய்ய விரும்புகிறீர்களா?",
  failedToStartUpload: "பதிவேற்றம் தொடங்க முடியவில்லை",
  failedToUploadChunk: "Chunk பதிவேற்ற முடியவில்லை",
  failedToFinalizeInvoice: "விலைப்பட்டியல் finalize செய்ய முடியவில்லை",
  failedToCancelInvoice: "பதிவேற்றலை ரத்து செய்ய முடியவில்லை",

  // Invoice List
  searchByInvoice: "விலைப்பட்டியல் எண் மூலம் தேடவும்",
  filterByStatus: "Status மூலம் Filter செய்யவும்",
  filterByDate: "தேதி மூலம் Filter செய்யவும்",
  invoiceNumberCol: "Invoice #",
  courierCompany: "கூரியர் நிறுவனம்",
  invoiceDateCol: "விலைப்பட்டியல் தேதி",
  totalOrdersCol: "மொத்த Orders",
  matchedOrdersCol: "Matched",
  statusCol: "Status",
  uploadedBy: "பதிவேற்றியது",
  uploadedOn: "பதிவேற்றிய தேதி",
  actions: "செயல்கள்",

  // Invoice Status
  pending: "Pending",
  processing: "Processing",
  completed: "Completed",
  failed: "Failed",
  partiallyProcessed: "Partially Processed",

  // Invoice Details
  invoiceInformation: "விலைப்பட்டியல் தகவல்",
  ordersSummary: "Orders சுருக்கம்",
  deliveryBreakdown: "Delivery Breakdown",
  matchStatusBreakdown: "Match Status Breakdown",
  discrepancies: "Discrepancies",
  invoiceOrders: "Invoice Orders",

  // Order Match Status
  matchStatus: "Match Status",
  orderMatched: "Matched",
  orderNotFound: "Not Found",
  orderAlreadyInvoiced: "Already Invoiced",
  orderIneligible: "Ineligible",

  // Delivery Status
  deliveryStatus: "Delivery Status",
  deliveryDelivered: "Delivered",
  deliveryReturned: "Returned",
  deliveryInTransit: "In Transit",
  deliveryOther: "Other",

  // Filters
  allStatuses: "அனைத்து Status",
  allDeliveryStatuses: "அனைத்து Delivery Status",
  allMatchStatuses: "அனைத்து Match Status",
  applyFilters: "Filter பயன்படுத்தவும்",
  resetFilters: "Filter Reset செய்யவும்",

  // Empty States
  noInvoicesYet: "விலைப்பட்டியல் இல்லை",
  uploadFirstInvoice: "முதல் விலைப்பட்டியல் பதிவேற்றவும்",
  noOrdersFound: "Orders இல்லை",
  noDiscrepanciesFound: "Discrepancies இல்லை",

  // Validation
  invoiceNumberRequired: "விலைப்பட்டியல் எண் தேவையானது",
  courierAccountRequired: "கூரியர் கணக்கு தேவையானது",
  invoiceDateRequired: "விலைப்பட்டியல் தேதி தேவையானது",
  fileRequired: "கோப்பு தேவையானது",
  invalidInvoiceDate: "விலைப்பட்டியல் தேதி எதிர்காலமாக இருக்க முடியாது",

  // Error Details
  errorFound: "Error(s) கண்டுபிடிக்கப்பட்டது",
  rowNumber: "Row #",
  airwaybillNumber: "Airwaybill #",
  errorMessage: "Error Message",

  // Statistics
  successRate: "Success Rate",
  totalInvoices: "மொத்த விலைப்பட்டியல்கள்",
  totalOrdersProcessed: "செயலாக்கப்பட்ட Orders",
  totalValueProcessed: "செயலாக்கப்பட்ட மதிப்பு",

  // Reprocessing
  reprocessing: "Reprocessing",
  reprocessingComplete: "Reprocessing முடிந்தது",
  ordersReprocessed: "Orders Reprocessed",
  successfullyReprocessed: "வெற்றிகரமாக Reprocess செய்யப்பட்டது",
  stillFailed: "இன்னும் Failed",

  // Confirmations
  deleteInvoiceConfirm: "இந்த விலைப்பட்டியலை நீக்க விரும்புகிறீர்களா?",
  reprocessFailedConfirm: "எல்லா failed orders-ஐ ரீ-ப்ராசஸ் செய்ய வேண்டுமா?",

  // Export
  exportInvoice: "Invoice Export",
  exportOrders: "Orders Export",
  exportDiscrepancies: "Discrepancies Export",

  // Details Page - Header
  backToInvoices: "விலைப்பட்டியல்களுக்கு திரும்பவும்",
  invoiceTitle: "Invoice {{number}}",
  uploadedByUser: "Uploaded by {{user}}",
  downloadPDF: "PDF பதிவிறக்கவும்",
  reprocessFailedOrders: "Failed orders Reprocess செய்யவும்",
  cancel: "Cancel",
  delete: "Delete",

  // Details Page - Summary Cards
  matchedOrders: "Matched Orders",

  // Details Page - Tabs
  overview: "Overview",
  ordersTab: "Orders ({{count}})",
  discrepanciesTab: "Discrepancies ({{count}})",
  timeline: "Timeline",

  // Details Page - Overview Tab
  financialBreakdown: "Financial Breakdown",
  totalCodCollected: "மொத்த COD வசூலிப்பு",
  totalCourierCharges: "மொத்த கூரியர் கட்டணங்கள்",
  processingMetadata: "Processing Metadata",
  fileName: "கோப்பு பெயர்",
  fileSize: "கோப்பு அளவு",
  rowsInFile: "Row எண்ணிக்கை",
  processingTime: "Processing நேரம்",
  seconds: "விநாடிகள்",

  // Details Page - Orders Tab
  searchByAirwaybill: "Airwaybill எண் மூலம் தேடவும்...",
  loadingOrders: "Orders Load ஆகிறது...",
  noOrdersMatchFilters: "Filters-க்கு பொருந்தும் Orders இல்லை",
  orderNumber: "Order Number",
  customerName: "Customer பெயர்",
  shop: "Shop",
  codAmount: "COD தொகை",
  courierCharge: "கூரியர் கட்டணம்",
  amountPayable: "செலுத்த வேண்டிய தொகை",
  viewDetails: "விவரங்கள் பார்க்கவும்",
  showingOrders: "{{from}} முதல் {{to}} வரை ({{total}})",

  // Details Page - Discrepancies Tab
  problemOrdersRequiringAttention: "கவனத்திற்கு வேண்டிய Orders",
  downloadReport: "Report பதிவிறக்கவும்",
  allOrdersMatched: "அனைத்து Orders Match ஆகியுள்ளது",
  notFoundInSystem: "System-ல் இல்லை ({{count}})",
  reprocessAll: "அனைத்தையும் Reprocess செய்யவும்",
  airwaybill: "Airwaybill",
  error: "Error",
  alreadyInvoicedGroup: "ஏற்கனவே Invoiced ({{count}})",
  order: "Order",
  ineligibleOrdersGroup: "தகுதி அற்ற Orders ({{count}})",

  // Details Page - Timeline Tab
  invoiceCreated: "Invoice உருவாக்கப்பட்டது",
  invoiceInitializedBy: "Invoice initialize செய்யப்பட்டது {{user}} மூலம்",
  invoiceNumberLabel: "Invoice Number",
  expectedOrders: "Expected Orders",
  processingStarted: "Processing தொடங்கப்பட்டது",
  startedProcessingInvoice: "Invoice process தொடங்கப்பட்டது",
  chunksUploaded: "Chunks Upload செய்யப்பட்டது",
  chunksCount: "{{received}} / {{expected}} chunks",
  orderDataUploadedInBatches: "Order data Batches-ஆக Upload செய்யப்பட்டது",
  processingCompleted: "Processing முடிந்தது",
  invoiceFinalizedWithStatus: "Invoice Finalized - {{status}}",
  processingTimeDuration: "Processing நேரம்: {{seconds}}s",
  lastUpdated: "கடைசியாக புதுப்பிக்கப்பட்டது",
  mostRecentModification: "Invoice-இல் சமீபத்திய மாற்றம்",

  // Details Page - Order Modal
  orderDetails: "Order விவரங்கள்",
  invoiceData: "Invoice Data",
  systemOrderData: "System Order Data",
  customer: "Customer",
  grandTotal: "Grand Total",
  noMatchingOrderFound: "Order காணப்படவில்லை",

  // Details Page - Confirmation Modal
  cancelButton: "Cancel",
  confirm: "Confirm",
  cancelInvoiceTitle: "Invoice ரத்து செய்யவும்",
  cancelInvoiceConfirm: "Invoice Cancel செய்யப்பட்டால் அனைத்து updates rollback ஆகும்",
  deleteInvoiceTitle: "Invoice நீக்கு",

  // Details Page - Error Messages
  failedToLoadInvoice: "Invoice load செய்ய முடியவில்லை",
  failedToLoadOrders: "Orders load செய்ய முடியவில்லை",
  failedToLoadDiscrepancies: "Discrepancies load செய்ய முடியவில்லை",
  failedToReprocessOrders: "Reprocess செய்ய முடியவில்லை",
  actionFailed: "செயல் தோல்வியடைந்தது",
  invoiceNotFound: "Invoice கிடைக்கவில்லை",
  loadingInvoiceDetails: "Invoice விவரங்கள் Load ஆகிறது...",

  // Details Page - Success Messages
  ordersReprocessedSuccess: "{{count}} orders Reprocess செய்யப்பட்டது",
  invoiceCancelledSuccess: "Invoice ரத்து செய்யப்பட்டது",
  invoiceDeletedSuccess: "Invoice நீக்கப்பட்டது",

  // Create Page - Header
  uploadAndProcessInvoices: "கூரியர் விலைப்பட்டியல்கள் Upload & Process செய்யவும்",

  // Create Page - Courier Selection
  courierAccountSelection: "கூரியர் கணக்கு தேர்வு",
  courierAccountLabel: "கூரியர் கணக்கு *",

  // Create Page - Invoice Form
  invoiceNumberLabel: "விலைப்பட்டியல் எண் *",
  invoiceDateLabel: "விலைப்பட்டியல் தேதி *",
  enterInvoiceNumberPlaceholder: "விலைப்பட்டியல் எண்ணை உள்ளிடவும்",

  // Create Page - File Upload
  uploadInvoiceFile: "விலைப்பட்டியல் கோப்பு Upload செய்யவும்",
  ordersCount: "{{count}} orders",
  columnMappingWarnings: "Column mapping எச்சரிக்கை ({{count}})",
  filePreviewTitle: "கோப்பு முன்னோட்டம் (முதல் 5 வரி)",
  missingRequiredColumn: "தேவையான நெடுவரிசை இல்லை: \"{{column}}\" / \"{{field}}\"",

  // Create Page - Progress
  processingChunkProgress: "Chunk {{current}} / {{total}} செயலாக்கம்",
  ordersProcessedProgress: "{{processed}} / {{total}} orders செயலாக்கம்",

  // Create Page - Results
  errorsFound: "{{count}} Error(s) கண்டுபிடிக்கப்பட்டது",

  // List Page - Main
  manageAndTrackInvoices: "அனைத்து கூரியர் விலைப்பட்டியல்களை நிர்வகிக்கவும் & கண்காணிக்கவும்",

  // List Page - Filters
  allCouriers: "அனைத்து கூரியர்கள்",
  searchByInvoice: "விலைப்பட்டியல் எண் மூலம் தேடவும்...",

  // List Page - Empty States
  noInvoicesFound: "விலைப்பட்டியல் இல்லை",
  noInvoicesFoundDescription: "Filters-க்கு பொருந்தும் விலைப்பட்டியல் இல்லை",
  uploadFirstInvoiceDescription: "முதல் விலைப்பட்டியல் பதிவேற்றவும்",

  // List Page - Bulk Actions
  deleteSelected: "தேர்வு செய்யப்பட்டவை நீக்கவும் ({{count}})",
  confirmBulkDelete: "{{count}} விலைப்பட்டியல் நீக்க வேண்டுமா?",
  bulkDeleteSuccess: "{{count}} விலைப்பட்டியல் நீக்கப்பட்டது",
  bulkDeleteFailed: "{{count}} நீக்க முடியவில்லை",
  failedToBulkDelete: "Delete செய்ய முடியவில்லை",

  // List Page - Actions
  cancelInvoice: "Invoice ரத்து செய்யவும்",
  failedToLoadInvoices: "Invoice load செய்ய முடியவில்லை",
  failedToCancel: "Cancel செய்ய முடியவில்லை",
  failedToDelete: "Delete செய்ய முடியவில்லை",

  // Modal - Titles & Actions
  cancelInvoiceTitle: "Invoice ரத்து செய்யவும்",
  deleteInvoiceTitle: "Invoice நீக்கவும்",
  confirmCancel: "Invoice ரத்து செய்யவும்",
  confirmDelete: "Invoice நீக்கவும்",
  cancelWarning: "இதன் மூலம் அனைத்து order updates rollback ஆகும்",
  deleteWarning: "இந்த செயலை மீண்டும் மாற்ற முடியாது",

  // Common
  amountPayable: "செலுத்த வேண்டிய தொகை",

  // Flags
  flagsTab: "Flags ({{count}})",
  flaggedOrders: "Flagged Orders",
  filterUnresolved: "Unresolved",
  filterResolved: "Resolved",
  filterAll: "All",
  recheckFlags: "Re-check Flags",
  flagsRechecked: "Checked {{checked}} orders, {{flagged}} flagged",
  failedToRecheckFlags: "Failed to re-check flags",
  failedToLoadFlags: "Failed to load flags",
  noFlags: "No flagged orders",
  flagReason_cod_mismatch: "COD Mismatch",
  flagReason_weight_mismatch: "Weight Mismatch",
  flagReason_delivery_charge_mismatch: "Delivery Charge Mismatch",
  flagReason_return_charge_mismatch: "Return Charge Mismatch",
  flagReason_paid_amount_mismatch: "Paid Amount Mismatch",
  flagReason_check_error: "Check Error",
  allFlagReasons: "All Flag Reasons",
  weight: "Weight (kg)",
  searchByAirwaybillOrOrder: "Search by airwaybill or order number...",
  flagExpectedVsInvoice: "Expected {{expected}} / Invoice {{actual}}",
  resolve: "Resolve",
  resolveFlagTitle: "Resolve Flag - {{airwaybill}}",
  resolveNote: "Resolve Note",
  resolveNotePlaceholder: "Explain how this was resolved...",
  resolvedByOn: "Resolved by {{user}} on {{date}}",
  flagResolved: "Flag resolved successfully",
  failedToResolveFlag: "Failed to resolve flag",
  flagReasonsColumn: "Flag Reasons",
  resolveNoteColumn: "Resolve Note",
  resolvedByOnShort: "by {{user}} · {{date}}"
};
